import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import area from '@turf/area'
import { Text } from 'components/Text'
import { Feature } from 'models/map'
import { readableNumber } from 'utils/readableNumber'
import { getCircleData } from 'utils/areaDetails'

type RadiusDescriptionProps = {
  selectedFeature: Feature
}

export const RadiusDescription: FC<RadiusDescriptionProps> = ({ selectedFeature }) => {
  const { t } = useTranslation()
  const [totalArea, totalLength] = getRadiusDetails(selectedFeature as any)

  return (
    <Text>
      <Text component="span">
        {t('confirmation_banner.area')}: {totalArea} m2
      </Text>
      {' - '}
      <Text component="span">
        {t('confirmation_banner.length')}: {totalLength} km
      </Text>
    </Text>
  )
}

RadiusDescription.displayName = 'RadiusDescription'

const getRadiusDetails = (feature: any) => {
  if (!feature) return [0, 0]

  const { radius } = getCircleData(feature)

  const totalLength = radius ? readableNumber(radius / 1000) : 0
  const totalArea = readableNumber(area(feature))

  return [totalArea, totalLength]
}
